import AttributeService from 'src/lib/api/attribute.service';

export async function searchAttributes({ commit }, { params }) {
  const response = await AttributeService.searchAttributes({ params });
  if (response.status === 200) {
    const key = (params.key) ? params.key : 'all';

    commit('updateAttributes', { attributes: response.data.data, key });
    commit('updateMeta', {
      meta: {
        next: response.data.next,
        previous: response.data.previous,
        rowCount: response.data.total,
      },
    });
  }
}
